import * as React from 'react';
import {get} from 'lodash';

import {EligibleForBonusReportContent} from '/component/partial/reportCard/EligibleForBonusReportContent';
import {useTranslation} from '/provider/TranslationProvider';
interface ReportRecordData {
  qsbFqv: number;
  newOrderingEntitiesCount: number;
  qsbRemainingEligibility: number;
  orderingEntities: Record<string, any>;
}
interface Props {
  recordData: ReportRecordData;
}

export const EligibleForQsbReportContent: React.FC<Props> = ({recordData}) => {
  const {ts} = useTranslation('reportCardContent.eligibleForQsb');
  const {qsbFqv, newOrderingEntitiesCount, qsbRemainingEligibility} =
    recordData;
  const orderingEntities = get(recordData, 'orderingEntities', {});
  const reportCardData = {
    orderingEntities,
    fqv: qsbFqv,
    newOrderingEntitiesCount,
    remainingEligibility: qsbRemainingEligibility,
  };
  return (
    <EligibleForBonusReportContent
      title={ts('heading', 'Eligible for Quick Start Bonus')}
      orderingEntitiesName={ts(
        'label.qsbOrderingEntities',
        'QSB Ordering Entities',
      )}
      fqvName={ts('label.qsbFqv', 'QSB Frontline Qualifying Volume')}
      recordData={reportCardData}
    />
  );
};
